import { Step } from 'element-ui'

const YStep = Step
YStep.$depends = [Step]
YStep.$name = 'y-step'
YStep._name = 'Step 步骤选项'

export default YStep
